import { PlanPackagesE } from "./../models/enums";
import { createSelector } from "@reduxjs/toolkit";
import { type RootState } from "./../../../../store/store";

export const selectActiveJMPlans = createSelector(
  (state: RootState) => state.purchases.activeJMPlans,
  (activeJMPlans) => activeJMPlans
);

export const selectPlanMaxStorage = createSelector(
  (state: RootState, planName: PlanPackagesE) =>
    state.purchases.activeJMPlans.find(
      (plan) => plan.Subscription_SystemName === planName
    )?.PackageDetails.MaxStorage,
  (MaxStorage) => MaxStorage
);
export const selectPlanMaxSubUsersQuantity = createSelector(
  (state: RootState, planName: PlanPackagesE) =>
    state.purchases.activeJMPlans.find(
      (plan) => plan.Subscription_SystemName === planName
    )?.PackageDetails.MaxSubUsers,
  (MaxSubUsers) => MaxSubUsers
);

export const selectCurrency = createSelector(
  (state: RootState) => state.purchases.currency,
  (currency) => currency
);

export const selectCouponCode = createSelector(
  (state: RootState) => state.purchases.couponCode,
  (couponCode) => couponCode
);

export const selectCreditCards = createSelector(
  (state: RootState) => state.purchases.creditCards,
  (creditCards) => creditCards
);

export const selectSelectedCreditCardId = createSelector(
  (state: RootState) => state.purchases.selectedCreditCardId,
  (selectedCreditCardId) => selectedCreditCardId
);
export const selectIsCreditCardsLoading = createSelector(
  (state: RootState) => state.purchases.isCreditCardsLoading,
  (isCreditCardsLoading) => isCreditCardsLoading
);

export const selectPaymentType = createSelector(
  (state: RootState) => state.purchases.paymentType,
  (paymentType) => paymentType
);

export const selectCompletedStep = createSelector(
  (state: RootState) => state.purchases.completedStep,
  (completedStep) => completedStep
);

export const selectCountries = createSelector(
  (state: RootState) => state.purchases.countries,
  (countries) => countries
);

export const selectAddonData = createSelector(
  (state: RootState) => state.purchases.addon,
  (addon) => addon
);

export const selectAddonQuantity = createSelector(
  (state: RootState) => state.purchases.addonQuantity,
  (addonQuantity) => addonQuantity
);

export const selectDowngradeAddonErrorMessage = createSelector(
  (state: RootState) => state.purchases.downgradeAddonErrorMessage,
  (downgradeAddonErrorMessage) => downgradeAddonErrorMessage
);

export const selectTransactionDetails = createSelector(
  (state: RootState) => state.purchases.transactionDetails,
  (transactionDetails) => transactionDetails
);

export const selectDowngradeDetails = createSelector(
  (state: RootState) => state.purchases.downgradeDetails,
  (downgradeDetails) => downgradeDetails
);

export const selectNewCreditCardIframeUrl = createSelector(
  (state: RootState) => state.purchases.newCreditCardIframeUrl,
  (newCreditCardIframeUrl) => newCreditCardIframeUrl
);

export const selectPurchasePrise = createSelector(
  (state: RootState) => state.purchases.purchasePrice,
  (purchasePrice) => purchasePrice
);

export const selectBillingData = createSelector(
  (state: RootState) => state.purchases.billingData,
  (billingData) => billingData
);

export const selectIsPurchaseFailed = createSelector(
  (state: RootState) => state.purchases.isPurchaseFailed,
  (isPurchaseFailed) => isPurchaseFailed
);

export const selectIsFetchingAddonData = createSelector(
  (state: RootState) => state.purchases.isFetchingAddonData,
  (isFetchingAddonData) => isFetchingAddonData
);

export const selectIsTransactionExecuting = createSelector(
  (state: RootState) => state.purchases.isTransactionExecuting,
  (isTransactionExecuting) => isTransactionExecuting
);

export const selectIsFetchingActiveJMPlans = createSelector(
  (state: RootState) => state.purchases.isFetchingActiveJMPlans,
  (isFetchingActiveJMPlans) => isFetchingActiveJMPlans
);

export const selectJumboCodeQuantity = createSelector(
  (state: RootState) => state.purchases.jumboCodeQuantity,
  (jumboCodeQuantity) => jumboCodeQuantity
);

export const selectIsForMonthlyPeriodOnly = createSelector(
  (state: RootState) => state.purchases.couponCode.isForMonthlyPeriodOnly,
  (isForMonthlyPeriodOnly) => isForMonthlyPeriodOnly
);

export const selectNewCreditCardIframeUrlError = createSelector(
  (state: RootState) => state.purchases.newCreditCardIframeUrlError,
  (newCreditCardIframeUrlError) => newCreditCardIframeUrlError
);

export const selectIsSubscriptionPurchase = createSelector(
  (state: RootState) => state.purchases.isSubscriptionPurchase,
  (isSubscriptionPurchase) => isSubscriptionPurchase
);

export const selectIsFetchingPurchasePrice = createSelector(
  (state: RootState) => state.purchases.isFetchingPurchasePrice,
  (isFetchingPurchasePrice) => isFetchingPurchasePrice
);
